/*! @azure/msal-common v7.4.1 2022-09-12 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "7.4.1";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
